import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nzmj9numer: FaireBrandEntity = {
  token: "b_nzmj9numer",
  type: "brand",
  name: "Sunshine Studios",
  avatarUrl:
    "https://cdn.faire.com/fastly/73c159c750f3827f71744ecb4d584153b1a8eaff71f1e13c53a32ebdbe05175d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/edf368013a5bbf50dd6cdb6d11ed289536a9e9548fa35120fe9cd1ef674717b7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/73c159c750f3827f71744ecb4d584153b1a8eaff71f1e13c53a32ebdbe05175d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/edf368013a5bbf50dd6cdb6d11ed289536a9e9548fa35120fe9cd1ef674717b7.png",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 133,
  isTopShop: true,
  isInsider: true,
  description:
    "At Sunshine Studios, every day is a reason to celebrate.  From colorful spring events and warm summer days to Halloween thrills, Christmas magic, and everything in between—we’re your destination for holiday cheer year-round.  Let our retro-inspired designs add a little magic to your space. Whether you're styling a mantel, wrapping the perfect gift, or looking for decor with vintage flair, we’ve got the goods to help you celebrate in style.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:11.535Z",
    importedBy: "entity-db-cli",
  },
};
